import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";

// get template

export const getTemplates = () => {
  const url = `templates`;
  return axiosClient.get<ResultDataModel<any>>(url);
};
